// RespiteCareSection.js
import React from 'react';
import respiteCareImage from '../assets/respite-care-showcase.jpg';

const RespiteCareSection = () => {
  return (
    <section className="py-16 px-6 md:px-12 lg:px-24 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          
          {/* Left Image */}
          <div>
            <img 
              src={respiteCareImage} 
              alt="Caregiver with elderly woman" 
              className="w-full h-auto rounded-2xl shadow-lg object-cover"
            />
          </div>

          {/* Right Content */}
          <div>
            <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6 leading-tight">
              Respite Care
            </h3>
            
            <div className="space-y-4 text-gray-700 font-light leading-relaxed mb-6">
              <p>
                Respite care provides temporary relief for family caregivers while ensuring that seniors continue to receive compassionate, reliable support at home. The caregivers we match step in to handle daily living tasks, provide companionship, and assist with personal care, allowing family members to rest, recharge, or attend to other responsibilities without worry.
              </p>
              
              <p>
                With flexible scheduling and personalised care plans, our respite services give families peace of mind knowing their loved ones are in experienced and caring hands. This support not only benefits seniors but also helps caregivers maintain their own well-being, ensuring long-term quality care for the entire family.
              </p>
            </div>
            
            <ul className="space-y-2 text-gray-700 font-light">
              <li className="flex items-start">
                <span className="mr-2">•</span>
                <span>Short-term relief</span>
              </li>
              <li className="flex items-start">
                <span className="mr-2">•</span>
                <span>Daily living help</span>
              </li>
              <li className="flex items-start">
                <span className="mr-2">•</span>
                <span>Companionship support</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RespiteCareSection;
